<template>
    <b-alert
        show 
        dismissible 
        :variant="variant"
        class="mx-0 mt-0 d-flex align-items-center"
    >
        <div 
            class="rounded-circle d-flex align-items-center justify-content-center mr-3 border"
            style="
                width: 48px; 
                height: 48px; 
                min-width: 48px; 
                border-color: #bee5eb; 
                background: #fff;
                margin-left: -10px;
            "
        >
            <i 
                :class="[icon, iconColor]"
                style="font-size: 20px;"
            />
        </div>
        <div>
            <slot/>
        </div>
    </b-alert>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: 'warning'
        },
        icon: {
            type: String,
            default: 'fa fa-info'
        },
        iconColor: {
            type: String,
            default: 'text-primary'
        },
    },
};
</script>
